'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import {
  IvBodyText,
  IvContentShell,
  IvSectionHeading,
  IvSectionLabel,
  IvSectionRoot,
} from './ivLoungeSectionLayout';
import styles from './IvLoungeBenefitsSection.module.css';

export const IvLoungeBenefitsSection: React.FC = () => {
  const t = useTranslations('performance-lab');

  const pointers = [
    {
      title: t('ivLounge.benefits.pointers.0.title'),
      body: t('ivLounge.benefits.pointers.0.body'),
    },
    {
      title: t('ivLounge.benefits.pointers.1.title'),
      body: t('ivLounge.benefits.pointers.1.body'),
    },
    {
      title: t('ivLounge.benefits.pointers.2.title'),
      body: t('ivLounge.benefits.pointers.2.body'),
    },
  ];

  return (
    <IvSectionRoot aria-label={t('ivLounge.benefits.aria')}>
      <IvContentShell className={styles.shell}>
        <div className={styles.headingColumn}>
          <IvSectionLabel>
            {t('ivLounge.benefits.overline')}
          </IvSectionLabel>
          <IvSectionHeading>
            {t('ivLounge.benefits.heading')}
          </IvSectionHeading>
        </div>

        <div className={styles.contentColumn}>
          <IvBodyText $muted className={styles.intro}>
            {t('ivLounge.benefits.intro')}
          </IvBodyText>

          <ol className={styles.pointerList}>
            {pointers.map((pointer, index) => (
              <li className={styles.pointerRow} key={pointer.title}>
                <span className={styles.pointerIndex}>
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className={styles.pointerTitle}>{pointer.title}</h3>
                <IvBodyText $muted>{pointer.body}</IvBodyText>
              </li>
            ))}
          </ol>

          <div className={styles.closing}>
            <IvBodyText $muted>
              {t('ivLounge.benefits.closing1')}
            </IvBodyText>
            <IvBodyText $muted>
              {t('ivLounge.benefits.closing2')}
            </IvBodyText>
          </div>
        </div>
      </IvContentShell>
    </IvSectionRoot>
  );
};
